import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getDepositRestrictions = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getDepositRestrictions()
}

// Do Not Remove this line ===@import api client===
